import { GlobalActionTypes, GlobalError, SET_GLOBAL_ERROR } from './types';

export const setGlobalError = (error: GlobalError): GlobalActionTypes => ({
  type: SET_GLOBAL_ERROR,
  payload: error,
});
